import { reloadPage } from './reloadPage'

const RELOAD_GUARD_KEY = 'neo-stale-chunk-reload-at'
const MIN_RELOAD_INTERVAL_MS = 10_000

// After a deploy, Cloudflare Pages serves the SPA fallback (HTTP 200 HTML) for
// the old hashed chunk URLs this tab still references, so lazy route imports
// reject. Reload once to pick up the new build; if the failure repeats within
// the guard window the deploy itself is broken, so let the error reach the
// ErrorBoundary instead of reload-looping.
export function setupStaleBuildReload() {
  window.addEventListener('vite:preloadError', (event) => {
    const lastReload = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) ?? 0)
    if (Date.now() - lastReload < MIN_RELOAD_INTERVAL_MS) {
      return
    }
    event.preventDefault()
    sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()))
    reloadPage()
  })
}
